import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getDeptExceptionData } from "src/api/sp";
import { resetStore } from "src/store/actions";
import {
  DeptExceptionInitialState,
  DeptExceptionRequestParams
} from "../../../config/tableInterface/interface";
import { getComponentKey, getItemTypes } from "src/utils/genericFunctions";
import { getFormatedDate } from "src/utils/getDates";
import { ITEM_TAGS_MAPPER } from "src/config/constants/genericConstants";

export const fetchDeptExceptionData = createAsyncThunk(
  "viewItems/fetchDeptExceptionData",
  (payload: DeptExceptionRequestParams) => getDeptExceptionData(payload)
);

const initialState: DeptExceptionInitialState = {
  data: [],
  recordsCount: null,
  status: "idle",
  error: null
};

const viewdeptExceptionData = createSlice({
  name: "viewdeptExceptionData",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(resetStore, (state, action) => {
        return initialState;
      })
      .addCase(fetchDeptExceptionData.pending, (state) => {
        state.status = "pending";
      })
      .addCase(fetchDeptExceptionData.fulfilled, (state, { payload }) => {
        state.status = "idle";
        if (payload?.data?.length > 0) {
          state.data = payload?.data?.map((item: any) => {
            const goiDeptChangeDate = getFormatedDate(
              item?.goiDeptChangeDate,
              "MM/DD/YYYY"
            );
            const storeDeptChangeDate = getFormatedDate(
              item?.storeDeptChangeDate,
              "MM/DD/YYYY"
            );
            const lastSoldDate = getFormatedDate(
              item?.lastSoldDate,
              "MM/DD/YYYY"
            );
            const itemTypes = getItemTypes(item);
            const tags = item.tags?.map((tag: string) => {
              if (ITEM_TAGS_MAPPER[tag]) {
                return ITEM_TAGS_MAPPER[tag];
              }
              return tag;
            });
            return {
              ...item,
              itemTypes,
              key: getComponentKey(),
              goiDeptChangeDate,
              storeDeptChangeDate,
              lastSoldDate,
              tags
            };
          });
          state.recordsCount = payload.recordsCount;
        } else {
          state.data = [];
          state.recordsCount = payload.recordsCount;
        }
      })
      .addCase(fetchDeptExceptionData.rejected, (state) => {
        state.status = "error";
        state.data = [];
      });
  }
});

export const selectViewItemAlertsTableData = ({
  viewItemAlertsTable
}: {
  viewItemAlertsTable: DeptExceptionInitialState;
}) => viewItemAlertsTable.data;

export const selectViewItemAlertsTableApiStatus = ({
  viewItemAlertsTable
}: {
  viewItemAlertsTable: DeptExceptionInitialState;
}) => viewItemAlertsTable.status;

export const selectViewItemAlertsTableError = ({
  viewItemAlertsTable
}: {
  viewItemAlertsTable: DeptExceptionInitialState;
}) => viewItemAlertsTable.error;

export default viewdeptExceptionData.reducer;
